import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Gift, Copy, Users, Clock, CheckCircle2 } from "lucide-react";

export default function Referral() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/referrals/me").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="py-20 text-center text-muted-foreground">Caricamento...</div>;

  const waText = encodeURIComponent(`Gestisci le tue case vacanza con Mypasspartu! Registrati con il mio link e riceviamo entrambi 1 mese gratuito: ${data.link}`);
  const copy = () => { navigator.clipboard.writeText(data.link); toast.success("Link copiato!"); };

  const Stat = ({ icon: Icon, label, value, color }) => (
    <div className="bg-card rounded-xl border border-border/80 p-4">
      <div className="flex items-center gap-2 text-xs text-muted-foreground"><Icon className={`h-4 w-4 ${color}`} /> {label}</div>
      <div className="font-mono-data font-bold text-2xl mt-1">{value}</div>
    </div>
  );

  return (
    <div className="space-y-6" data-testid="referral-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Invita & Guadagna</h1>
        <p className="text-muted-foreground mt-1 text-sm">Condividi Mypasspartu: quando un invitato diventa cliente pagante, <strong>tu e lui ricevete 1 mese gratuito</strong>. I mesi si sommano!</p>
      </div>

      <div className="bg-card border-2 border-[#E3FF00] rounded-xl p-5 space-y-3">
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Il tuo link di invito</div>
        <div className="flex flex-col sm:flex-row gap-2">
          <input readOnly value={data.link} data-testid="referral-link" className="flex-1 bg-background border border-input rounded-lg px-3 py-2.5 text-sm font-mono-data" />
          <button onClick={copy} data-testid="referral-copy" className="bg-[#E3FF00] text-neutral-900 font-semibold px-4 py-2.5 rounded-lg hover:brightness-95 flex items-center justify-center gap-2"><Copy className="h-4 w-4" /> Copia</button>
        </div>
        <a href={`https://wa.me/?text=${waText}`} target="_blank" rel="noreferrer" data-testid="referral-whatsapp" className="w-full bg-[#E3FF00] text-neutral-900 font-semibold px-4 py-3 rounded-lg hover:brightness-95 flex items-center justify-center gap-2">
          <Gift className="h-4 w-4" /> Condividi su WhatsApp
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <Stat icon={Users} label="Invitati totali" value={data.total} color="text-blue-600" />
        <Stat icon={Clock} label="In attesa" value={data.pending} color="text-amber-600" />
        <Stat icon={CheckCircle2} label="Diventati paganti" value={data.rewarded} color="text-emerald-600" />
        <Stat icon={Gift} label="Mesi guadagnati" value={data.months_earned} color="text-primary" />
      </div>

      <div className="bg-card rounded-xl border border-border/80 overflow-x-auto" data-testid="referral-table">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-border text-left text-xs uppercase text-muted-foreground">
            <th className="px-4 py-3 font-semibold">Azienda invitata</th><th className="px-4 py-3 font-semibold">Stato</th>
          </tr></thead>
          <tbody className="divide-y divide-border/60">
            {data.referrals.map((r, i) => (
              <tr key={i}>
                <td className="px-4 py-3">{r.org_name}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${r.status === "rewarded" ? "bg-emerald-500/10 text-emerald-700" : "bg-amber-500/10 text-amber-700"}`}>
                    {r.status === "rewarded" ? "Pagante · +1 mese" : "In prova"}
                  </span>
                </td>
              </tr>
            ))}
            {data.referrals.length === 0 && <tr><td colSpan={2} className="px-4 py-8 text-center text-muted-foreground">Nessun invito ancora. Condividi il tuo link!</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
